$('.new-accordion').on('click','.accord-heading', function() {
    if($(this).hasClass('active')){
        $(this).next('.accord-content').slideUp();
        $(this).removeClass('active');
    }else{
        $(this).find('.accord-heading').removeClass('active');
        $(this).parent().find('.accord-content').slideUp();
        $(this).next('.accord-content').slideDown();
        $(this).addClass('active')
    }
    return false;
});